export default {
  general: {
    name: "Flow Simulation Game",
    yes: "Yes",
    no: "No",
    previous: "Previous",
    next: "Next",
    ok: "Ok",
    confirmation: "Confirm",
    week: "Week",
    units: "{nbr} unit | {nbr} unit | {nbr} units",
    smallWeek: "W",
    timerMessage: "You have exceeded the time limit, please take action as soon as possible!",
    wrongValue: "Incorrect value",
    gameFinished: "The game is over",
    gamePaused: "The game is paused",
    required: "Required",
    stockFrom: "Inventory from",
    assemblyStock: "Assembled inventory",
    testMode: "This game is in test mode. It cannot be used for commercial purposes."
  },
  
  instructions: {
    chooseAvatar: "Choose your avatar",
    title: "Instructions",
    step: "Step",
    ready: "I'm ready to play",
    wait: "Please wait for the other participants to be ready",
    start: "Start the game"
  },

  steps: {
    bufferSetup: "Buffer settings",
    clientOrder: "Sales Orders",
    clientShipment: "Customer Shipments",
    supplierShimpentWaiting: "Waiting for deliveries",
    board: "Dashboard",
    supplierShipments: "Supplier Deliveries",
    supplierOrders: "Supplier Orders",
    productionBatch: "Production start",
    productionShipments: "Production Deliveries",
    startNewWeek: "Start a new week",
    youCanStartNewWeek: "You can start a new week",
    inProgressProduction: "Work In Process",
    flowEquationCalc: "Net Flow Equation",
    clientOrderTitleMessage: "You received a sales order"
  },

  clientsShimpents: {
    chooseQuantity: "Please enter your shipments",
    notMax: "Please ship to the best of your ability",
    remains: "Sales orders (past due & due today) : ",
    ok : "Validate shipments",
    shipmentsResume: "You shipped {nbr} unit to your customers | You shipped {nbr} units to your customers",
    remainResume: "You have a backorder of {nbr} unit | You have a backorder of {nbr} units"
  },

  board: {
    cantOrder: "You can not order at the moment",
    cantProduce: "You can not start a production order at the moment"
  },

  suppliersShipments: {
    shipments: "Deliveries from",
    production: "You produced {nbr} unit | You produced {nbr} units",
    getShipments: "Receive",
    waitShipment: "Please wait for deliveries",
    stockChange: "Your inventory is now {nbr} unit | Your inventory is now {nbr} units",
    stockChangeTitle: "Update of your inventory"
  },

  suppliersOrders: {
    maxOrder: "Maximum order ",
    ordersTo: "Orders to",
    remainsAlert: "As a reminder, you failed to deliver all your customer orders !",
    production: "Qty to start",
    orders: "Orders",
    ok : "Validate supplier orders",
    okProduction: "Validate production starts"
  },

  stats: {
    suppliersRemains: "Suppliers Backorders",
    buffers: "Buffers",
    resume: "Summary",
    orders: "Orders",
    stock: "Inventory",
    remains: "Shortages",
    cost: "Costs",
    stockDelay: "Inventory & shortages",
    companies: "Node",
    red: "Red Zone",
    yellow: "Yellow Zone",
    green: "Green Zone",
    flowEquation: "Net Flow"
  },

  dd: {
    cmj: "Average Daily Usage",
    leadTime: "Lead time",
    variabilityFactor: "Variability Factor",
    delayFactor: "Leadtime Factor",
    availableStock: "On-Hand Inventory",
    clientsRemains: "Qualified Demand",
    suppliersRemains: "Supply orders",
    AverageStockLevelTarget: "Average Inventory Target",
    falseOrder: "You did not order the right quantity",
    applyAutoCmj: "Auto apply calculated Average Daily Usage",
    calculatedCMJ: "Calculated Average Daily Usage",
    bufferWeekExplanation: `Net Flow and inventory level are recorded at 3 key times of the week
    1st point: after customer order
    2nd point: after customer shipment
    3rd point: after receipt and supplier order`
  },

  debrief: {
    resume: {
      name: "Name",
      level: "Rank",
      resume: "Summary",
      averageOrderQuantity: "Average demand to the supplier",
      averageRequestQuantity: "Average customer demand",
      range: "Demand range",
      otd: "On Time Delivery",
      delaysDepth: "Delays in weeks",
      averageStock: "Average on-hand inventory",
      stockCost: "Inventory Cost",
      delayCost: "Shortages Cost",
      cost: "Total Cost",
    }
  },

  user : {
    noParties : 'No game matches this code and this account',
    falseTrainningKey : 'Incorrect trainer key',
    welcome : "Welcome to the game ",
    noMorePlace : "There is no seat left for this game",
    notOpen: "The game is open",
    logoutConfirmation: "Are you sure you want to leave the game ?",
    sessionExpired: "Your session has expired, please log in again"
  },

  store : {
    error : "Error : "
  }
}